import type { PContainer } from '../../engine/aliases'
import type { IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { l } from '../../lib/imports'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import type { IStevieText2 } from '../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'

export interface IVoyageFloatingText extends IEntity {
  text: IStevieText2
  timeSecMax: number
  timeSecElapsed: number
  x: number
  y: number
}

const objs: IVoyageFloatingText[] = []
export function getAll() {
  return objs
}

export function create(
  x: number,
  y: number,
  toSay: string,
  layer: PContainer | null = null,
): IVoyageFloatingText {
  // underPerf.recordCreate('floating-text')

  let id = -1 // createId()

  if (!layer) {
    layer = voyageLayers.getLayers().uiOnCam
  }

  let text = stevieTexts2.create(echoFonts.getData().font4, x, y, layer)
  stevieTexts2.setText(text, toSay)
  stevieTexts2.setScale(text, 4)

  let obj: IVoyageFloatingText = {
    eType: 'goat-misc',
    id,
    idLoaded: 0,
    isDead: false,
    text,
    timeSecMax: 5,
    timeSecElapsed: 0,
    x,
    y,
  }
  objs.push(obj)
  return obj
}

export function moveTo(obj: IVoyageFloatingText, x: number, y: number) {
  obj.x = x
  obj.y = y
  stevieTexts2.moveTo(obj.text, x, y)
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    stevieTexts2.kill(c.text)
  })
}
function update(obj: IVoyageFloatingText) {
  let ds = common.getUpdateDelta()
  obj.timeSecElapsed += ds

  moveTo(obj, obj.x, obj.y - ds * 20)

  let d = obj.timeSecMax - obj.timeSecElapsed
  if (d < 1 && d > 0) {
    stevieTexts2.setAlpha(obj.text, d)
  }

  if (obj.timeSecElapsed > obj.timeSecMax) {
    obj.isDead = true
  }
}
